// extracted by mini-css-extract-plugin
export default {"modal":"Modal--modal--YOWUT","show":"Modal--show--u0+ja","link":"Modal--link--aKXWT","linkContainer":"Modal--link-container--l8OdE"};